import { h as e } from "vue";
import { getColorFromString as l } from "./ghl-ui.es71.js";
import { getInitials as o } from "./ghl-ui.es209.js";
import a from "./ghl-ui.es249.js";
const t = (r = {}) => ({
  round: !0,
  size: 24,
  style: r
}), g = (r) => r.imageUrl ? e(a, {
  src: r.imageUrl,
  ...t({
    flex: "none",
    ...r.avatarClass
  })
}) : e(
  a,
  t({
    backgroundColor: l(r.label),
    fontSize: "10px",
    flex: "none",
    ...r.avatarClass
  }),
  {
    default: () => o(r.label)
  }
);
export {
  g as renderAvatar
};
